import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';

import Capsule from '../Capsule';
import DollarAmount from '../../shared/DollarAmount';

import './FinesTotalCapsule.scss';

export default function FinesTotalCapsule({ status, amount }) {
  const formattedStatus = status && status.toLowerCase();

  const className = cn(
    'cp-fines-total-capsule',
    formattedStatus,
    { 'is-zero': amount === 0 }
  );

  return (
    <Capsule className={className}>
      <FormattedMessage id={`fines_total_${formattedStatus}`} values={{ amount: <DollarAmount amount={amount} /> }} />
    </Capsule>
  );
}

FinesTotalCapsule.propTypes = {
  status: PropTypes.string,
  amount: PropTypes.number
};



// WEBPACK FOOTER //
// ./app/components/borrowing/fines/FinesTotalCapsule/FinesTotalCapsule.jsx